import { useEffect } from "react";
import { motion } from "framer-motion";
import { Instagram, ExternalLink } from "lucide-react";

const PROFILE_URL = "https://www.instagram.com/ashleyfalls_pta/";

export const InstagramFeed = () => {
  useEffect(() => {
    const existing = document.querySelector('script[src="https://www.instagram.com/embed.js"]');
    if (!existing) {
      const script = document.createElement("script");
      script.async = true;
      script.src = "https://www.instagram.com/embed.js";
      document.body.appendChild(script);
    }
    const timer = setTimeout(() => {
      window.instgrm?.Embeds?.process();
    }, 600);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section id="instagram" data-testid="instagram-section" className="relative py-20 lg:py-28 grid-bg">
      <div className="neon-hairline absolute top-0 left-0 right-0" />
      <div className="max-w-4xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-pink-500">Follow along</p>
          <h2 className="mt-3 text-3xl md:text-4xl font-black uppercase tracking-tight text-slate-900">
            The fun, <span className="neon-cyan-shadow">live</span> from campus
          </h2>
          <p className="mt-3 text-sm md:text-base font-medium text-slate-600 max-w-xl mx-auto">
            Beach days, carnivals, and classroom wins — see what your membership
            makes possible at{" "}
            <a
              href={PROFILE_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="instagram-handle-link"
              className="font-bold text-pink-500 hover:text-pink-600 transition-colors"
            >
              @ashleyfalls_pta
            </a>
            .
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: 0.15 }}
          data-testid="instagram-embed-wrapper"
          className="mt-10 mx-auto flex min-h-[420px] justify-center rounded-2xl bg-white p-2 sm:p-3 border border-slate-200 shadow-[0_0_30px_rgba(217,70,239,0.12)] max-w-[560px]"
        >
          <blockquote
            className="instagram-media"
            data-instgrm-permalink={PROFILE_URL}
            data-instgrm-version="14"
            style={{
              background: "#fff",
              border: 0,
              borderRadius: 12,
              margin: 0,
              maxWidth: 540,
              minWidth: 280,
              padding: 0,
              width: "calc(100% - 2px)",
            }}
          >
            <a
              href={PROFILE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="block p-10 text-slate-600 font-semibold"
            >
              View @ashleyfalls_pta on Instagram
            </a>
          </blockquote>
        </motion.div>

        <motion.a
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          href={PROFILE_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="instagram-follow-button"
          className="mt-8 inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-gradient-to-r from-pink-500 via-fuchsia-500 to-purple-500 text-white text-xs font-bold uppercase tracking-widest hover:shadow-[0_0_22px_rgba(217,70,239,0.55)] transition-shadow"
        >
          <Instagram size={16} /> Follow @ashleyfalls_pta <ExternalLink size={13} />
        </motion.a>
      </div>
    </section>
  );
};
